import { TextInput } from '@ordr-as/umami-react/form';
import { Dispatch, SetStateAction, useState } from 'react';
import { useIntl } from 'react-intl';

interface TipFieldProps {
  amountToPay: number;
  setTipAmount: Dispatch<SetStateAction<number | undefined>>;
  setIsTipAmountValid: Dispatch<SetStateAction<boolean>>;
}

const TipField = ({ amountToPay, setTipAmount, setIsTipAmountValid }: TipFieldProps) => {
  const { formatMessage } = useIntl();
  const [totalInkTips, setTotalInkTips] = useState<string>('');
  const [totalInkTipsError, setTotalInkTipsError] = useState<string>('');

  const handleOnChange = (input: string) => {
    setTotalInkTips(input);
    const inputAsNumber = parseFloat(input);

    if (isNaN(inputAsNumber) && input !== '') {
      setTotalInkTipsError(formatMessage({ id: 'payment.invoice.dialog.error.notANumber' }));
      setTipAmount(undefined);
      setIsTipAmountValid(false);
      return;
    }

    if (inputAsNumber < amountToPay) {
      setTotalInkTipsError(formatMessage({ id: 'payment.invoice.dialog.error.totalInkTipsTooLow' }));
      setTipAmount(undefined);
      setIsTipAmountValid(false);
      return;
    }

    setTotalInkTipsError('');

    const calculatedTipAmount = inputAsNumber - amountToPay;
    const roundedTipAmount = Math.round(calculatedTipAmount * 100) / 100; //

    setTipAmount(roundedTipAmount);
    setIsTipAmountValid(true);
  };

  return (
    <TextInput
      label={formatMessage({ id: 'generic.totalIncTips' })}
      className="mb-4"
      inputMode="numeric"
      fullWidth
      value={totalInkTips}
      onChange={handleOnChange}
      validationState={totalInkTipsError ? 'invalid' : undefined}
      invalidHelpText={totalInkTipsError}
      invalidHelpClassName="mt-1"
    />
  );
};

export default TipField;
